"use client";

import { X, ChevronLeft, ChevronRight, ZoomIn, ZoomOut } from "lucide-react";
import { createPortal } from "react-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const filters = ["All", "New Homes", "Investment", "Challenging Lots", "Additions"];
const fallbackEntries = [{
  id: "f1",
  title: "Modern Mountain Residence",
  sector: "New Homes",
  year: "2024",
  src: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_23_56-AM-scaled.png",
  srcset: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_23_56-AM-scaled.png",
  sizes: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_23_56-AM-scaled.png",
  gallery_images: ["https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_23_56-AM-scaled.png", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-04_32_28-AM-1-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-04_32_31-AM-3-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-04_32_31-AM-2-scaled.jpg"],
  link: "#"
}, {
  id: "f2",
  title: "Contemporary Mixed Material",
  sector: "New Homes",
  year: "2026",
  src: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-1-scaled.jpg",
  srcset: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-1-scaled.jpg",
  sizes: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-1-scaled.jpg",
  gallery_images: ["https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-1-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-2-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-3-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-09_30_09-AM-4-scaled.jpg"],
  link: "#"
}, {
  id: "f3",
  title: "Modern Woodland Cabin",
  sector: "Challenging Lots",
  year: "2024",
  src: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_19_16-AM-scaled.jpg",
  srcset: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_19_16-AM-scaled.jpg",
  sizes: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_19_16-AM-scaled.jpg",
  gallery_images: ["https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-01_19_16-AM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-02_47_23-AM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-02_54_41-AM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-02_19_24-AM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-04_23_51-AM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-04_23_14-AM-1-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-02_58_39-AM-scaled.jpg"],
  link: "#"
}, {
  id: "f4",
  title: "Contemporary Duplex",
  sector: "Investment",
  year: "2024",
  src: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-19-2026-12_44_17-PM-scaled.jpg",
  srcset: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-19-2026-12_44_17-PM-scaled.jpg",
  sizes: "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-19-2026-12_44_17-PM-scaled.jpg",
  gallery_images: ["https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-19-2026-12_44_17-PM-scaled.jpg", "https://acumendb.services/wp-content/uploads/2026/06/gigapixel-ChatGPT-Image-Jun-21-2026-06_39_59-AM-scaled.jpg"],
  link: "#"
}];
const layoutPositions = [{
  col: "md:col-start-1 md:col-end-7",
  aspect: "aspect-[3/2]",
  offset: "",
  side: "left"
}, {
  col: "md:col-start-8 md:col-end-13",
  aspect: "aspect-[3/2]",
  offset: "md:mt-24",
  side: "right"
}, {
  col: "md:col-start-1 md:col-end-6",
  aspect: "aspect-[3/2]",
  offset: "",
  side: "left"
}, {
  col: "md:col-start-7 md:col-end-13",
  aspect: "aspect-[3/2]",
  offset: "md:mt-12",
  side: "right"
}];
interface ArchiveEntry {
  id: string;
  title: string;
  sector: string;
  year: string;
  src: string;
  srcset?: string;
  sizes?: string;
  gallery_images: string[];
  link: string;
  isPost?: boolean;
}

// Helper to compute wrapper size from image natural dimensions
function computeSize(naturalWidth: number, naturalHeight: number) {
  const padding = 128;
  const maxW = Math.min(window.innerWidth - padding, 1152);
  const maxH = window.innerHeight * 0.88;
  const ratio = Math.min(maxW / naturalWidth, maxH / naturalHeight);
  return {
    width: `${Math.round(naturalWidth * ratio)}px`,
    height: `${Math.round(naturalHeight * ratio)}px`
  };
}
function GalleryModal({
  images,
  currentIndex,
  onClose,
  onNext,
  onPrev,
  originRect,
  initialSize
}: {
  images: string[];
  currentIndex: number;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
  originRect: DOMRect | null;
  initialSize: {
    width: string;
    height: string;
  } | null;
}) {
  const outImgRef = useRef<HTMLImageElement>(null);
  const inImgRef = useRef<HTMLImageElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const fullscreenRef = useRef(false);
  const displayedIndexRef = useRef(currentIndex);
  const targetIndexRef = useRef(currentIndex);
  const isAnimatingRef = useRef(false);
  const startTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const endTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasLoadedRef = useRef(false);
  const [counter, setCounter] = useState(currentIndex);
  const [fullscreen, setFullscreen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  // Start with initialSize if provided so wrapper is correct size before modal opens
  const [wrapperSize, setWrapperSize] = useState<{
    width: string;
    height: string;
  }>(initialSize ?? {
    width: "100%",
    height: "100%"
  });
  const measureAndSetSize = (imgEl: HTMLImageElement) => {
    if (!imgEl.naturalWidth) return;
    setWrapperSize(computeSize(imgEl.naturalWidth, imgEl.naturalHeight));
    if (!hasLoadedRef.current) {
      hasLoadedRef.current = true;
      setHasLoaded(true);
    }
  };
  useEffect(() => {
    if (outImgRef.current) {
      outImgRef.current.src = images[displayedIndexRef.current];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, [images]);

  // If initialSize was provided, mark as loaded immediately so transitions are enabled
  useEffect(() => {
    if (initialSize && !hasLoadedRef.current) {
      hasLoadedRef.current = true;
      setHasLoaded(true);
    }
  }, [initialSize]);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 20);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    fullscreenRef.current = fullscreen;
    if (!outImgRef.current?.naturalWidth) return;
    if (fullscreen) {
      const padding = 64;
      const maxW = window.innerWidth - padding;
      const maxH = window.innerHeight - padding;
      const img = outImgRef.current;
      const ratio = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
      setWrapperSize({
        width: `${Math.round(img.naturalWidth * ratio)}px`,
        height: `${Math.round(img.naturalHeight * ratio)}px`
      });
    } else {
      measureAndSetSize(outImgRef.current);
    }
  }, [fullscreen]);
  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose(), 600);
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        if (fullscreen) {
          setFullscreen(false);
        } else {
          handleClose();
        }
      }
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    window.addEventListener("keydown", handleKeyDown);
    const scrollY = window.scrollY;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, [onClose, onNext, onPrev, fullscreen]);
  const runAnimation = (from: number, to: number) => {
    if (from === to) return;
    isAnimatingRef.current = true;
    const outEl = outImgRef.current;
    const inEl = inImgRef.current;
    if (!outEl || !inEl) return;
    const dir = to > from ? "left" : "right";
    const outEnd = dir === "left" ? "-100%" : "100%";
    const inStart = dir === "left" ? "100%" : "-100%";
    outEl.src = images[from];
    outEl.style.transform = "translateX(0)";
    outEl.style.transition = "none";
    outEl.style.display = "block";
    inEl.src = images[to];
    inEl.style.transform = `translateX(${inStart})`;
    inEl.style.transition = "none";
    inEl.style.display = "block";

    // Read dimensions from preloaded cache
    // Don't resize during animation — keep wrapper at current size
    // Size will snap to correct dimensions after animation completes

    setCounter(to);
    if (startTimerRef.current) clearTimeout(startTimerRef.current);
    if (endTimerRef.current) clearTimeout(endTimerRef.current);
    startTimerRef.current = setTimeout(() => {
      if (!outImgRef.current || !inImgRef.current) return;
      const easing = "transform 900ms cubic-bezier(0.76, 0, 0.24, 1)";
      outImgRef.current.style.transition = easing;
      outImgRef.current.style.transform = `translateX(${outEnd})`;
      inImgRef.current.style.transition = easing;
      inImgRef.current.style.transform = "translateX(0)";
    }, 20);
    endTimerRef.current = setTimeout(() => {
      displayedIndexRef.current = to;
      isAnimatingRef.current = false;
      if (!outImgRef.current || !inImgRef.current) return;
      outImgRef.current.src = images[to];
      outImgRef.current.style.transform = "translateX(0)";
      outImgRef.current.style.transition = "none";
      inImgRef.current.style.display = "none";

      // Snap wrapper to incoming image's exact size after slide completes
      const dest = new Image();
      dest.src = images[to];
      const snapSize = (img: HTMLImageElement) => {
        if (!img.naturalWidth) return;
        const padding = fullscreenRef.current ? 64 : 128;
        const maxW = fullscreenRef.current ? window.innerWidth - padding : Math.min(window.innerWidth - padding, 1152);
        const maxH = fullscreenRef.current ? window.innerHeight - padding : window.innerHeight * 0.88;
        const ratio = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
        const w = Math.round(img.naturalWidth * ratio);
        const h = Math.round(img.naturalHeight * ratio);
        setWrapperSize({
          width: `${w}px`,
          height: `${h}px`
        });
        if (!hasLoadedRef.current) {
          hasLoadedRef.current = true;
          setHasLoaded(true);
        }
      };
      if (dest.complete && dest.naturalWidth) {
        snapSize(dest);
      } else {
        dest.onload = () => snapSize(dest);
      }
      if (targetIndexRef.current !== to) {
        runAnimation(to, targetIndexRef.current);
      }
    }, 920);
  };
  useEffect(() => {
    targetIndexRef.current = currentIndex;
    if (!isAnimatingRef.current) {
      runAnimation(displayedIndexRef.current, currentIndex);
    }
  }, [currentIndex]);
  const getOriginTransform = () => {
    if (!originRect || typeof window === "undefined") return "scale(0.96)";
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const cx = originRect.left + originRect.width / 2 - vw / 2;
    const cy = originRect.top + originRect.height / 2 - vh / 2;
    const scale = Math.min(originRect.width / vw, originRect.height / vh) * 0.8;
    return `translate(${cx}px, ${cy}px) scale(${scale})`;
  };
  return createPortal(<div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 md:p-8" onClick={handleClose}>
      {/* Background — fades only */}
      <div className="absolute inset-0 backdrop-blur-sm" style={{
      backgroundColor: "rgba(0,0,0,0.95)",
      opacity: visible ? 1 : 0,
      transition: "opacity 600ms cubic-bezier(0.76, 0, 0.24, 1)"
    }} />

      {/* Close button — fades independently */}
      <Button variant="ghost" size="icon" onClick={e => {
      e.stopPropagation();
      handleClose();
    }} className="absolute top-6 right-6 text-white hover:bg-white/10 rounded-lg z-[10000]" style={{
      opacity: visible ? 1 : 0,
      transition: "opacity 600ms cubic-bezier(0.76, 0, 0.24, 1)"
    }}>
        <X className="size-6" />
      </Button>

      {/* Counter — fades independently */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 font-mono text-xs tracking-widest uppercase text-white/60 z-10 select-none" style={{
      opacity: visible ? 1 : 0,
      transition: "opacity 600ms cubic-bezier(0.76, 0, 0.24, 1)"
    }}>
        {counter + 1} / {images.length}
      </div>

      {/* Modal content — animates from card origin */}
      <div className="relative w-full h-full flex items-center justify-center" style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translate(0,0) scale(1)" : originRect && typeof window !== "undefined" ? getOriginTransform() : "scale(0.96)",
      transition: "opacity 600ms cubic-bezier(0.76, 0, 0.24, 1), transform 600ms cubic-bezier(0.76, 0, 0.24, 1)"
    }}>
        <div className="relative flex items-center justify-center w-full h-full">
          
          <div className="relative w-full h-full flex items-center justify-center">
  <div style={{
            position: "relative"
          }}>
    <span style={{
              position: "absolute",
              left: "-4rem",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10
            }} onClick={e => e.stopPropagation()}>
      <Button variant="ghost" size="icon" onClick={e => {
                e.stopPropagation();
                onPrev();
              }} disabled={currentIndex === 0} className="text-white hover:bg-white/10 rounded-lg disabled:opacity-20">
        <ChevronLeft className="size-8" />
      </Button>
    </span>

    <div ref={wrapperRef} style={{
              position: "relative",
              width: wrapperSize.width,
              height: wrapperSize.height,
              borderRadius: "20px",
              overflow: "hidden",
              transition: hasLoaded ? "width 900ms cubic-bezier(0.76, 0, 0.24, 1), height 900ms cubic-bezier(0.76, 0, 0.24, 1)" : "none"
            }}>
      <img ref={outImgRef} alt="Gallery image" draggable={false} style={{
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                userSelect: "none",
                pointerEvents: "none"
              }} />
      <img ref={inImgRef} alt="Gallery image" draggable={false} style={{
                display: "none",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                userSelect: "none",
                pointerEvents: "none"
              }} />
      <button onClick={e => {
                e.stopPropagation();
                setFullscreen(f => !f);
              }} className="absolute bottom-3 right-3 z-20 p-2 rounded-lg bg-black/20 text-white/40 hover:text-white/90 hover:bg-black/40 hover:scale-110 transition-all duration-300 ease-out">
        {fullscreen ? <ZoomOut className="size-4" /> : <ZoomIn className="size-4" />}
      </button>
    </div>

    <span style={{
              position: "absolute",
              right: "-4rem",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10
            }} onClick={e => e.stopPropagation()}>
      <Button variant="ghost" size="icon" onClick={e => {
                e.stopPropagation();
                onNext();
              }} disabled={currentIndex === images.length - 1} className="text-white hover:bg-white/10 rounded-lg disabled:opacity-20">
        <ChevronRight className="size-8" />
      </Button>
    </span>
  </div>
</div>

          
        </div>
      </div>
    </div>, document.body);
}
function ProjectCard({
  entry,
  onClick
}: {
  entry: ArchiveEntry;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}) {
  const [hovered, setHovered] = useState(false);
  return <div className="relative overflow-hidden rounded-lg shadow-md cursor-pointer" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={onClick} style={{
    width: "100%",
    height: "100%"
  }}>
      <img src={entry.src} {...!entry.isPost && {
      "data-wvc-srcset": entry.srcset,
      "data-wvc-sizes": entry.sizes
    }} alt={entry.title} loading="lazy" decoding="async" style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transform: hovered ? "scale(1.03)" : "scale(1)",
      transition: "transform 600ms ease-out"
    }} />
      <div style={{
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: hovered ? 1 : 0,
      transition: "opacity 300ms ease",
      borderRadius: "inherit"
    }}>
        <span style={{
        fontFamily: "inherit",
        fontSize: "0.875rem",
        fontWeight: 600,
        letterSpacing: "0.1em",
        textTransform: "uppercase",
        color: "#ffffff"
      }}>
          Click to View More
        </span>
      </div>
    </div>;
}
function AnimatedCard({
  entry,
  index,
  pos,
  onSelectProject
}: {
  entry: ArchiveEntry;
  index: number;
  pos: typeof layoutPositions[0];
  onSelectProject: (id: string, rect: DOMRect) => void;
}) {
  const ref = useRef<HTMLElement>(null);
  const isLeft = pos.side === "left";
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([obsEntry]) => {
      if (obsEntry.isIntersecting) {
        el.style.opacity = "1";
        el.style.transform = "translateX(0)";
      } else {
        el.style.opacity = "0";
        el.style.transform = isLeft ? "translateX(-120px)" : "translateX(120px)";
      }
    }, {
      threshold: 0,
      rootMargin: "20% 0px 20% 0px"
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [isLeft]);
  return <article ref={ref} data-index={index} className={`group cursor-pointer ${pos.col} ${pos.offset}`} style={{
    opacity: 0,
    transform: isLeft ? "translateX(-120px)" : "translateX(120px)",
    transition: `opacity 1200ms cubic-bezier(0.22, 1, 0.36, 1) ${index * 150}ms, transform 1600ms cubic-bezier(0.22, 1, 0.36, 1) ${index * 150}ms`
  }}>
      <div className="border-t border-border pt-6 transition-colors duration-300 group-hover:border-primary">
        <div className={`${pos.aspect} overflow-hidden rounded-lg shadow-md`}>
          <ProjectCard entry={entry} onClick={e => {
          const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
          onSelectProject(entry.id, rect);
        }} />
        </div>
        <h3 className="font-default text-xl md:text-2xl font-semibold tracking-tight text-foreground mt-6 transition-transform duration-300 ease-out group-hover:-translate-x-2">
          {entry.title}
        </h3>
        <p className="font-default text-sm font-medium tracking-wide text-muted-foreground mt-3 uppercase">
          {entry.sector} · {entry.year}
        </p>
      </div>
    </article>;
}
function GalleryConsumer({
  activeFilter,
  onSelectProject,
  onEntriesResolved
}: {
  activeFilter: string;
  onSelectProject: (id: string, rect: DOMRect) => void;
  onEntriesResolved: (entries: ArchiveEntry[]) => void;
}) {
  const {
    posts,
    loading,
    hasNext,
    hasPrev,
    nextPage,
    prevPage,
    currentPage,
    totalPages
  } = usePosts();
  const [visible, setVisible] = useState(true);
  const [displayedFilter, setDisplayedFilter] = useState(activeFilter);
  useEffect(() => {
    if (activeFilter === displayedFilter) return;
    setVisible(false);
    const timer = setTimeout(() => {
      setDisplayedFilter(activeFilter);
      setVisible(true);
    }, 350);
    return () => clearTimeout(timer);
  }, [activeFilter]);
  let entries: ArchiveEntry[] = [];
  if (loading) {
    entries = [];
  } else if (posts && posts.length > 0) {
    entries = posts.slice(0, 12).map((post, idx) => {
      const sector = post.categories?.[0]?.name || fallbackEntries[idx % fallbackEntries.length].sector;
      const year = post.date ? new Date(post.date).getFullYear().toString() : fallbackEntries[idx % fallbackEntries.length].year;
      const galleryImages = post.acf?.gallery_images || post.meta?.gallery_images || (post.featuredImage ? [post.featuredImage] : [fallbackEntries[idx % fallbackEntries.length].src]);
      return {
        id: post.id,
        title: post.title,
        sector,
        year,
        src: post.featuredImage || fallbackEntries[idx % fallbackEntries.length].src,
        gallery_images: galleryImages,
        link: post.link || "#",
        isPost: true
      };
    });
  } else {
    entries = fallbackEntries;
  }
  useEffect(() => {
    if (!loading) {
      onEntriesResolved(entries);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, posts]);
  const filtered = displayedFilter === "All" ? entries : entries.filter(e => e.sector.toLowerCase() === displayedFilter.toLowerCase());
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 md:gap-x-8 gap-y-16 md:gap-y-24 mt-16">
        {[...Array(4)].map((_, i) => <div key={i} className={`${layoutPositions[i % layoutPositions.length].col} ${layoutPositions[i % layoutPositions.length].offset}`}>
            <div className="border-t border-border pt-6">
              <div className={`${layoutPositions[i % layoutPositions.length].aspect} bg-muted animate-pulse rounded-lg`} />
              <div className="mt-6 h-6 w-2/3 bg-muted animate-pulse" />
              <div className="mt-3 h-4 w-1/3 bg-muted animate-pulse" />
            </div>
          </div>)}
      </div>;
  }
  if (filtered.length === 0) {
    return <div className="mt-16 col-span-12">
        <p className="text-muted-foreground">No projects to display in this category.</p>
      </div>;
  }
  return <>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 md:gap-x-8 gap-y-16 md:gap-y-24 mt-16" style={{
      transform: visible ? "translateX(0)" : "translateX(-40px)",
      opacity: visible ? 1 : 0,
      transition: "transform 350ms cubic-bezier(0.4, 0, 0.2, 1), opacity 350ms ease"
    }}>
        {filtered.map((entry, i) => {
        const pos = layoutPositions[i % layoutPositions.length];
        return <AnimatedCard key={entry.id} entry={entry} index={i} pos={pos} onSelectProject={onSelectProject} />;
      })}
      </div>

      {(hasNext || hasPrev) && totalPages > 1 && <div className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-12">
          <div className="md:col-start-5 md:col-end-9 flex items-center justify-between border-t border-border pt-6">
            <Button variant="ghost" onClick={prevPage} disabled={!hasPrev} className="rounded-lg px-0 text-sm font-semibold tracking-wide uppercase text-foreground hover:text-primary hover:bg-transparent disabled:opacity-30">
              ← Previous
            </Button>
            <span className="font-default text-sm font-semibold tracking-wide text-muted-foreground uppercase">
              Page {currentPage} of {totalPages}
            </span>
            <Button variant="ghost" onClick={nextPage} disabled={!hasNext} className="rounded-lg px-0 text-sm font-semibold tracking-wide uppercase text-foreground hover:text-primary hover:bg-transparent disabled:opacity-30">
              Next →
            </Button>
          </div>
        </div>}
    </>;
}
export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [resolvedEntries, setResolvedEntries] = useState<ArchiveEntry[]>(fallbackEntries);
  const [originRect, setOriginRect] = useState<DOMRect | null>(null);
  const [initialSize, setInitialSize] = useState<{
    width: string;
    height: string;
  } | null>(null);
  const sentinelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('[data-portfolio-text]')) as HTMLElement[];
    const reset = () => {
      els.forEach(el => {
        el.style.transition = "none";
        el.style.opacity = "0";
        el.style.visibility = "hidden";
        el.style.transform = "translateY(20px)";
      });
    };
    const animate = () => {
      els.forEach((el, i) => {
        el.style.visibility = "visible";
        el.style.transition = `opacity 600ms cubic-bezier(0.76, 0, 0.24, 1) ${i * 100}ms, transform 600ms cubic-bezier(0.76, 0, 0.24, 1) ${i * 100}ms`;
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      });
    };
    reset();
    let preloaded = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reset();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              animate();
            });
          });
          if (!preloaded) {
            preloaded = true;
            resolvedEntries.forEach(project => {
              project.gallery_images.forEach(src => {
                const img = new Image();
                img.src = src;
              });
            });
          }
        } else {
          reset();
        }
      });
    }, {
      threshold: 1.0
    });
    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [resolvedEntries]);
  const handleSelectProject = (id: string, rect: DOMRect) => {
    setSelectedProjectId(id);
    setCurrentImageIndex(0);
    setOriginRect(rect);
    setInitialSize(null);

    // Measure first image synchronously before modal mounts
    const entry = resolvedEntries.find(e => e.id === id);
    if (entry?.gallery_images[0]) {
      const img = new Image();
      img.src = entry.gallery_images[0];
      const compute = (i: HTMLImageElement) => {
        setInitialSize(computeSize(i.naturalWidth, i.naturalHeight));
      };
      if (img.complete && img.naturalWidth) {
        compute(img);
      } else {
        img.onload = () => compute(img);
      }
    }
  };
  const selectedProject = resolvedEntries.find(e => e.id === selectedProjectId);
  const handleNext = useCallback(() => {
    if (selectedProject && currentImageIndex < selectedProject.gallery_images.length - 1) {
      setCurrentImageIndex(prev => prev + 1);
    }
  }, [selectedProject, currentImageIndex]);
  const handlePrev = useCallback(() => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(prev => prev - 1);
    }
  }, [currentImageIndex]);
  return <section id="project-showcase" className="bg-background py-32 md:py-44 dark">
      <div id="portfolio" className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-16">
        <div ref={sentinelRef} style={{
        height: "1px",
        marginBottom: "-1px"
      }} aria-hidden="true" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 md:gap-x-8 items-end">
          <div data-portfolio-text className="md:col-start-1 md:col-end-9">
            <h1 className="font-default text-5xl md:text-7xl lg:text-[5rem] font-bold tracking-tight leading-[0.96] text-foreground">
              Project Portfolio
            </h1>
          </div>
          <div data-portfolio-text className="md:col-start-10 md:col-end-13 mt-6 md:mt-0">
            <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed">
              Contemporary residential design, 2018–2025
            </p>
          </div>
        </div>
        <div className="mt-12 border-t border-border" />
        <div data-portfolio-text className="py-8 -mx-5 md:mx-0 px-5 md:px-0 overflow-x-auto md:overflow-visible">
          <div className="flex items-center gap-2 md:gap-3 min-w-max md:min-w-0 md:flex-wrap">
            {filters.map((filter, i) => {
            const isActive = activeFilter === filter;
            return <Badge key={filter} data-index={i} variant="outline" onClick={() => setActiveFilter(filter)} className={`cursor-pointer rounded-lg px-4 py-2 text-xs font-semibold tracking-wide uppercase transition-all transition-transform duration-300 ease-out ${isActive ? "border-primary text-primary bg-accent/50 scale-105" : "border-border text-foreground bg-transparent hover:border-primary"}`}>
                  {filter}
                </Badge>;
          })}
          </div>
        </div>
        <PostsProvider wp_query={new WP_Query({
        post_type: "post",
        per_page: 12,
        order: "desc",
        orderby: "date"
      })}>
          <GalleryConsumer activeFilter={activeFilter} onSelectProject={handleSelectProject} onEntriesResolved={setResolvedEntries} />
        </PostsProvider>
        {selectedProjectId && selectedProject && <GalleryModal images={selectedProject.gallery_images} currentIndex={currentImageIndex} onClose={() => setSelectedProjectId(null)} onNext={handleNext} onPrev={handlePrev} originRect={originRect} initialSize={initialSize} />}
      </div>
    </section>;
}